import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { modalStyle } from "../../../../../../../../components/modalStyle";
import TrimListDataSheet from ".";
import { useVendorDataSheet } from "./useVendorDataSheet";

export default function VendorDataSheetModal({
  currentDataSheet,
  open,
  onClose,
  isVendor = false,
  onSaveDataSheet,
  submittedDataSheet,
}) {
  const {
    vendorState,
    isEditable,
    setEditable,
    handleChange,
    getFieldState,
    onSave,
  } = useVendorDataSheet({
    dataSheet: currentDataSheet ?? {},
    onSaveDataSheet,
    submittedDataSheet,
  });

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ ...modalStyle, width: "auto", p: 0, maxHeight: "90%" }}>
        <TrimListDataSheet
          vendor={{ name: currentDataSheet?.vendorName }}
          data={currentDataSheet}
          isVendor={isVendor}
          isEditable={isEditable}
          onEditToggle={() => setEditable((v) => !v)}
          onSave={onSave}
          vendorState={vendorState}
          getFieldState={getFieldState}
          onChange={handleChange}
          onClose={onClose}
        />
      </Box>
    </Modal>
  );
}
